<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Accounts.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtName"><small class="text-danger">*</small> {{$lang.Accounts.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          ref="txtAccountName"
                          :placeholder="$lang.Accounts.PlaceholderEnterName"
                          v-model="form.nome.value"
                          :maxlength="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtUsername"><small class="text-danger">*</small> {{$lang.Accounts.LabelUsername}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          ref="CompUsername"
                          :placeholder="$lang.Accounts.PlaceholderEnterUsername"
                          v-model="form.username.value"
                          :maxlength="form.username.maxlength"
                          :required="form.username.required"
                          :state="form.username.state"
                          @change="onCheckUsername"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtEmail"><small class="text-danger">*</small> {{$lang.Accounts.LabelEmail}}:</label>
          <div class="input-group">
            <b-form-input type="email"
                          :placeholder="$lang.Accounts.PlaceholderEnterEmail"
                          v-model="form.email.value"
                          :maxlength="form.email.maxlength"
                          :required="form.email.required"
                          :state="form.email.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-2">
          <label for="txtPhone"><small v-show="form.telefoneCelular.required" class="text-danger">*</small> {{$lang.Accounts.LabelMobilePhone}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtPhone"
                          :placeholder="$lang.Accounts.PlaceholderMobilePhone"
                          v-model="form.telefoneCelular.value"
                          :maxlength="form.telefoneCelular.maxlength"
                          :required="form.telefoneCelular.required"
                          :state="form.telefoneCelular.state"
                          v-mask="['(##) # ####-####']"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger">*</small> {{$lang.Accounts.LabelGroup}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.grupoID.value" :options="form.grupoID.options" class="mb-3" >
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtEmpresa"><small class="text-danger">*</small> {{$lang.Accounts.LabelCompany}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.empresaID.value" :options="form.empresaID.options" class="mb-3" >
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtInsured"> Funcionário:</label>
          <autocomplete-z ref="funcionarioTypeahead"
                          placeholder="Digite o nome do Funcionário"
                          iconClass="fas fa-hard-hat"
                          :serializer="(funcionario) => funcionario.codigo + ' - ' + funcionario.nome"
                          :debounceLength="3"
                          :formField="form.funcionarioID"
                          v-on:search="onSearchFuncionario"
                          v-on:changeCode="onChangeCodeFuncionario" />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 pt-1">
          <h5 class="text-third"><i class="fa fa-lock"></i> {{$lang.Accounts.AccessPasswords}}</h5>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtPassword"><small class="text-info">*</small> {{$lang.Accounts.LabelPassword}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-lock"></i></span>
            <b-form-input type="password"
                          :placeholder="$lang.Accounts.PlaceholderEnterPassword"
                          v-model="form.senha.value"
                          :maxlength="form.senha.maxlength"
                          :required="form.senha.required"
                          :state="form.senha.state"
                          autocomplete="new-password"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtConfirmation"><small class="text-info">*</small> {{$lang.Accounts.LabelConfirmation}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-lock"></i></span>
            <b-form-input type="password"
                          :placeholder="$lang.Accounts.PlaceholderConfirmationPassword"
                          v-model="form.confirmation.value"
                          :maxlength="form.confirmation.maxlength"
                          :required="form.confirmation.required"
                          :state="form.confirmation.state"
                          autocomplete="new-password"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <small class="text-third"><i class="fa fa-info-circle"></i> {{$lang.Accounts.PasswordOnlyNewRegistration}}</small>
        </div>
      </div>
    </Forms>
    <Tables ref="tableGrid"
            :columns="[$lang.Accounts.DataTable.Name,
                       $lang.Accounts.DataTable.Company,
                       $lang.Accounts.DataTable.Group,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <template #formBeforeTable>
        <div class="mt-1 mx-1">
          <b-form-input :placeholder="$lang.Accounts.PlaceholderSearch" v-model="nameSearch">
          </b-form-input>
        </div>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.nome" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.empresa ? obj.empresa.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.grupo.nome" />
        <TableColumn :IsStatus="true" v-on:Edit="onSelect(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataAcao" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.nomeContaAcao" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import Account from './account.js'

export default Account
</script>



// WEBPACK FOOTER //
// src/views/private/access/account/account.vue